// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ObjectTypesType from 'customer-data-objects-ui-components/propTypes/ObjectTypesType';
import customErrorTypes from '../../constants/customErrorTypes';
import PropTypes from 'prop-types';
export default PropTypes.oneOfType([ObjectTypesType, PropTypes.oneOf(Object.keys(customErrorTypes))]);